<template>
  <ion-app>
    <ion-alert-controller></ion-alert-controller>
    <!--    <main-popup-modal />-->
    <MissionPopup v-if="this.$store.state.showMissionPopup"/>
    <div class="loading-spinner" v-show="$store.getters.isLoading"></div>
    <audio-player-new ref="player" style="z-index: 999"/>
    <hamburger/>
    <new-header v-if="showHeaderBar && $store.getters.getIsShowHeaderBar"/>
    <footer-toolbar v-show="isMainPage"/>
    <router-view id="routerView" :key="$route.fullPath" class="main-rooter-view"
                 :style="{top: showHeaderBar && $store.state.isShowHeaderBar ? '130px' : '0',
                 paddingBottom: isMainPage ? '110px' : '20px', zIndex: $store.state.routerZIndex}" />
    <component :is="$store.state.modal.name" :visible.sync="$store.state.modal.visible" :data="$store.state.modal.data" style="z-index: 1000"/>
    <NoticePopup />
  </ion-app>
</template>

<script>
import * as ajax from './utils/ajax'
import * as alert from './utils/alert'
import * as biz from "./utils/biz"
import * as utils from "./utils/utils"
import Hamburger from "./components/Hamburger";
import AudioPlayer from "./components/AudioPlayer";
import AudioPlayerNew from "./components/AudioPlayerNew";
import FooterToolbar from "./components/footer/FooterToolbar";
import MainPopupModal from "./views/main/MainPopupModal";
import './css/checkbox.css';
import MissionPopup from "@/components/popup/MissionPopup";
import NewHeader from "@/components/header/NewHeader";
import NoticePopup from "./components/popup/NoticePopup";
import {mapState} from "vuex"
import BonusPopup from "./components/popup/BonusPopup";
import ReportPopup from "./components/popup/ReportPopup";

export default {
  name: "App",
  components: {NewHeader, MissionPopup, AudioPlayer, AudioPlayerNew, Hamburger, FooterToolbar,
    MainPopupModal, NoticePopup, BonusPopup, ReportPopup},
  data() {
    return {
      app: {
        version: "1.0"
      },
      regist_app_version: "",
      appversion: "",
      isShowGuide: false
    }
  },
  mounted() {
    var splits = window.navigator.userAgent.split("|");
    if (splits.length > 2) {
      var appversion = splits[splits.length - 1]
      this.appversion = appversion.replace(".", '').replace(".", '');
    } else
      this.appversion = "0";

    // 공통쿠키 검색
    if (this.$cookie.get("schoolDiv") === null) {
      this.$cookie.set("schoolDiv", "", 365);
    }
    if (this.$cookie.get("schoolGrade") === null) {
      this.$cookie.set("schoolGrade", "", 365);
    }
    if (this.$cookie.get("lteStreaming") === null) {
      this.$cookie.set("lteStreaming", false, 365);
    }

    var accessToken = this.$cookie.get("accessToken");
    if (accessToken == null)
      accessToken = "";
    var schoolDiv = this.$cookie.get("schoolDiv");
    if (schoolDiv == null)
      schoolDiv = "";
    var schoolGrade = this.$cookie.get("schoolGrade");
    if (schoolGrade == null)
      schoolGrade = "";
    const params = {
      accessToken: accessToken,
      schoolDiv: schoolDiv,
      schoolGrade: schoolGrade
    };
    // console.log('setAccessToken :' + params);
    switch (utils.deviceInfo()) {
      case "Android":
        // this.getAppVersion("01");
        window.listenApp.setAccessToken(JSON.stringify(params));
        window.listenApp.hideSplash();
        window.listenApp.deviceInfo();
        break;
      case "iOS":
        // this.getAppVersion("02");
        window.webkit.messageHandlers.setAccessToken.postMessage(params);
        window.webkit.messageHandlers.hideSplash.postMessage();
        break;
    }

    window.deviceInfo = this.androidDeviceInfo;

    // Android back button 기능정의
    if (utils.deviceInfo() === "Android") {
      window.backClick = this.backButton;
    }

  },
  created() {
    this.$store.watch(
        (state) => {
          return this.$store.state.basicPlayerVisibility // could also put a Getter here
        },
        (newValue, oldValue) => {
          //something changed do something
          console.log("---------------basicPlayerVisibility-----------------");
          console.log('----------old: ',oldValue)
          console.log('----------new: ',newValue)
          console.log(this.$store.state.playerMode)
          if (newValue && this.$store.state.playerMode === 'basic') {
            this.$store.state.isShowHeaderBar = false;
          } else {
            this.$store.state.isShowHeaderBar = true;
          }
        });
    this.$store.watch(
        (state) => {
          return this.$store.state.playerMode // could also put a Getter here
        },
        (newValue, oldValue) => {
          //something changed do something
          console.log("---------------playMode-----------------");
          console.log('----------old: ',oldValue)
          console.log('----------new: ',newValue)
          console.log(this.$store.state.playerMode)
          if (newValue === 'mini') {
            this.$store.state.isShowHeaderBar = true;
          } else {
            this.$store.state.isShowHeaderBar = !this.$store.state.basicPlayerVisibility
          }
        },
    )
  },
  methods: {
    changePage(){
      debugger;
    },
    // getAppVersion(appCode) {
    //   const param = {
    //     "group_code": "APP_VERSION_DIV",
    //     "code": appCode
    //   };
    //
    //
    //   ajax.Post(this, "/api/common/code/search", param, function(ref, data) {
    //     ref.regist_app_version = data[0].value.replace(".", '').replace(".", '');
    //
    //     console.info("appversion = " + ref.appversion);
    //     console.info("regist_app_version = " + ref.regist_app_version);
    //     if (Number(ref.appversion) < Number(ref.regist_app_version) || ref.appversion == "0") {
    //       ref.updateAppGuide(appCode)
    //     }
    //   });
    // },
    androidDeviceInfo(deviceToken, deviceId, appVersion) {
      this.app.version = appVersion;

      if (this.app.version < 1.2) {
        const storeLink = "https://play.google.com/store/apps/details?id=com.textbooklistening.android";
        alert.alertLink("There is a new update. \nPlease update to the new version.", "확인", this, storeLink);
      }
    },
    backButton() {
      if (this.$refs.player.playerInfo.mode === "basic") {
        this.$refs.player.playerInfo.mode = "mini";
      } else {
        this.$router.go(-1);
      }
    }
    // ,
    // updateAppGuide(deviceType) {
    //
    //   // // android 가 준비되면 다시 오픈
    //   // if (deviceType === "01")
    //   //   return;
    //
    //   if (this.isShowGuide)
    //     return;
    //   this.isShowGuide = true;
    //
    //   var message = "<b>포켓튜터</b>의 새로운 버전이 등록되였습니다.\n";
    //   if (deviceType === "01")
    //     message += "PlayStore를 통해 <b>포켓튜터</b>의 새로운 버전으로 다시 설치해 주세요. \n감사합니다.";
    //   else
    //     message += "AppStore를 통해 <b>포켓튜터</b>의 새로운 버전으로 다시 설치해 주세요. \n감사합니다.";
    //
    //
    //   document.querySelector('ion-alert-controller').create({
    //     message: message,
    //     buttons: [
    //       {
    //         text: "확인",
    //         role: 'cancel',
    //         cssClass: 'secondary',
    //         handler: () => {
    //           // console.log('Confirm Cancel');
    //           this.isShowGuide = false;
    //         },
    //       },
    //     ],
    //     mode: "ios"
    //   }).then(alert => {
    //     alert.present();
    //   });
    // }

    // callIsconnectWIFI() {
    //     window.listenApp.isConnectWIFI();
    // },
    // callAudioList() {
    //     window.listenApp.getAudioList();
    // },
    // receiveIsconnectWIFI(value) {
    //     console.log(value);
    // },
    // receiveOfflineAudioFileList(fileList) {
    //     for (const item of fileList) {
    //         console.log(item);
    //     }
    // }
  },
  watch:{
    '$route' (to, from) {
      this.$refs.player.setMiniPlayer();
    }
  },
  computed: {
    isMainPage() {
      let patterns = ['/listen', '/listen/mission', '/listen/praise_stamp', '/listen/my_listen_note', '/listen/talk_teacher'
        , '/curriculum', '/community', '/community/self_tb', '/community/playlist', '/community/playlist_info'
        , '/community/board', '/community/board_detail'
        , '/community/challenge', '/community/challenge_participate_detail', '/community/challenge_participate_user_detail'
        , '/search', '/home', '/mycontent/best','/mycontent/recommended', '/mycontent/mycontent' ,'/preview/lecture/plan/00','/preview/lecture/subject/00','/preview/teacher'
          , '/mytextbook/course/listen', '/mytextbook/course/interest', '/mytextbook/teacher', '/mytextbook/playlist'
          , '/mytextbook/course/put', "/preview/lecture/info/"
      ]
      // .includes(this.$route.path);
      let rlt = false;

      for(let keyword of patterns){
        var patt = new RegExp(keyword);
        if (patt.test(this.$route.path)){
          rlt = true;
          break;
        }
      }
      this.$store.state.miniPlayerBottom = rlt ? "90px" : "0";
      return rlt;
    },
    showHeaderBar() {
      return ['/listen', '/listen/mission', '/listen/praise_stamp', '/listen/my_listen_note','/listen/listen_note_detail', '/listen/talk_teacher'
        , '/curriculum', '/community', '/community/self_tb', '/community/playlist', '/community/playlist_info'
        , '/community/board', '/community/board_detail'
        , '/community/challenge', '/community/challenge_participate_detail', '/community/challenge_participate_user_detail'
        , '/home'].includes(this.$route.path) && this.$store.state.isShowHeaderBar;
    },
  },
}
</script>

<style lang="scss">
:root {
  --ion-font-family: "Noto Sans KR", sans-serif;

  // 기존에 등록된 컬러는 컬러만 변경
  --ion-color-primary: #ff6b00;
  --ion-color-primary-rgb: 255, 107, 0;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 0, 0, 0;
  --ion-color-primary-shade: #e05e00;
  --ion-color-primary-tint: #ff7a1a;
}

.main-rooter-view {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
</style>
